import { KibButtonNew } from '@chewy/kib-controls-react/legacy';
import { KibChewyPlusLogo } from '@chewy/kib-logos-react';
import { useTranslation } from 'react-i18next';

import { HeroImage } from '@/components/membership-dashboard/HeroImage/HeroImage';
import { PetProfileModel } from '@/generated-client/pet-profile-a';

import styles from './SignUpHeroSectionV1.module.scss';

export interface Props {
  petProfiles: PetProfileModel[];
  handleOpenConfirmationSheet: () => void;
}

export default function SignUpHeroSectionV1({ petProfiles, handleOpenConfirmationSheet }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.aboveTheFoldContainer}>
      <div className={styles.grid1}>
        <div style={{ maxWidth: '975px' }}>
          <HeroImage isGeneric={true} petProfiles={petProfiles} />
        </div>
        <div className={styles.welcomeSection}>
          <KibChewyPlusLogo className={styles.chewyPlusImage} />
          <h3 className={styles.header}>{t('loyalty.sign-up.page-title')}</h3>
          <p className={styles.subHeader}>{t('loyalty.sign-up.page-subtitle')}</p>
          <div className={styles.signUpBtnContainer}>
            <KibButtonNew
              data-testid="sign-up:hero:open-confirmation-sheet-btn"
              emphasis="tertiary"
              onClick={handleOpenConfirmationSheet}
              size="medium"
            >
              {t('loyalty.sign-up.try-for-free')}
            </KibButtonNew>
          </div>
        </div>
      </div>
    </div>
  );
}
